<template>
  <ProductFilter
    :isOnProductDetailPage="isOnProductDetailPage"
    :placeholderText="placeholderText"
    :totalFiltersActive="totalFiltersActive"
    filterType="vendor"
    title="Vendors"
    tooltipText="For example, nike or vans"
  />
</template>

<script>
  import ProductFilter from '@/components/ProductFilter'

  export default {
    name: 'ProductFilterVendors',
    components: {
      ProductFilter
    },
    props: {
      isOnProductDetailPage: Boolean,
      totalFiltersActive: Number
    },
    computed: {
      placeholderText: function () {
        return 'Start typing "Brand"'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ProductFilterVendors.vue